import { signInWithEmailAndPassword } from "@firebase/auth";
import { useState, type FormEvent } from "react";
import { AuthCard, Layout } from "../components/Layout";
import { Field, FormError, PasswordField, SubmitButton } from "../components/Form";
import { GoogleButton } from "../components/GoogleButton";
import { firebaseAuth } from "../firebase";
import { errorMessage } from "../messages";
import { Link, Redirect } from "../router";
import { homeFor, useSession } from "../session";

export function SignIn() {
  const { session } = useSession();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [formError, setFormError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (session.status === "signed-in") {
    // Wait for the account, so the redirect goes to the right page.
    return session.me || session.error ? <Redirect to={homeFor(session.me)} /> : null;
  }

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setFormError(null);
    if (!email.trim() || !password) {
      setFormError("הזינו אימייל וסיסמה.");
      return;
    }
    setBusy(true);
    try {
      await signInWithEmailAndPassword(firebaseAuth(), email.trim(), password);
    } catch (error) {
      setFormError(errorMessage(error));
      setBusy(false);
    }
  };

  return (
    <Layout>
      <AuthCard title="התחברות" subtitle="ברוכים השבים ל-FrameFlow.">
        <form onSubmit={(event) => void submit(event)} noValidate>
          <Field
            label="אימייל"
            type="email"
            dir="ltr"
            value={email}
            onChange={setEmail}
            autoComplete="email"
            inputMode="email"
          />
          <PasswordField label="סיסמה" value={password} onChange={setPassword} autoComplete="current-password" />
          <p className="forgot">
            <Link to="/forgot-password">שכחתם את הסיסמה?</Link>
          </p>
          <FormError message={formError} />
          <SubmitButton busy={busy}>התחברות</SubmitButton>
        </form>
        <GoogleButton onError={setFormError} />
        <p className="switch">
          אין לכם חשבון עדיין? <Link to="/signup">פתיחת חשבון</Link>
        </p>
      </AuthCard>
    </Layout>
  );
}
